angular.module('EdxFtue')
  .controller('EdxFtuePageController', [
    '$scope',
    '$timeout',
    '$window',
    'authentication',
    'dblAnalyticsProvider',
    'edxCustomerSettingsService',
    'navigation',
    function(
      $scope,
      $timeout,
      $window,
      authentication,
      dblAnalytics,
      edxCustomerSettingsService,
      navigation
    ) {
      var vm = this;

      vm.hideFtueModel = edxCustomerSettingsService.getHideFtue();

      var customerSubscription = authentication.getCustomerSubject().subscribe(function (customer) {
         vm.customer = customer;
         vm.customerLabel = 'c' + customer.id;
      });

      vm.saveHideFtue = saveHideFtue;

      vm.viewMyDashboardClicked = function () {
        dblAnalytics.eventTrack('View My Dashboard', {
          category: 'FTUE',
          eventType: 'click',
          label: vm.customerLabel
        });

        navigation.goHome();
      };

      $scope.$on('$destroy', function () {
        customerSubscription.dispose();
      });

      function saveHideFtue () {
        edxCustomerSettingsService.setHideFtue(vm.hideFtueModel);

        var eventName = vm.hideFtueModel ? 'Hide FTUE' : 'Show FTUE';
        dblAnalytics.eventTrack(eventName, {
          category: 'FTUE',
          eventType: 'click',
          label: vm.customerLabel
        });
      }

    }]);
